import { isCountableUnit } from './scenarioCalculations';

export const formatQuantityWithUnit = (
    value,
    unit,
    category,
    showStandardized = false,
    standardizedValue = null,
    baseUnit = null
) => {
    const isCountable = isCountableUnit(unit, category);
    const formattedValue = isCountable ? Math.round(value).toLocaleString() : value.toFixed(2);
    let displayUnitText = '';

    if (unit === 'S') {
        displayUnitText = 'units';
    } else if (unit) {
        displayUnitText = unit.toLowerCase();
    }

    if (showStandardized && standardizedValue != null && baseUnit != null && !isCountable) {
        const formattedStandardized = standardizedValue.toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });

        return `${formattedStandardized} ${baseUnit} (${formattedValue} ${displayUnitText})`;
    }

    return `${formattedValue} ${displayUnitText}`;
};

export const formatCurrency = (value) => {
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    }).format(value);
};
